import React, { Component } from "react";
import { Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import { Messages, MessagesLink, Counter } from "./styles/actions-styles";
import * as storage from "../../../storage";

class MessagesNotifications extends Component {
  menuLinkOnClick = () => {
    storage.local.removeItem("conversations-list-mobile-hidden", "mobile-out");
    storage.local.setItem("conversations-list-mobile-shown", "mobile-in");
  };

  render() {
    const { unreadMessages, messagesUrl } = this.props;

    return (
      <Messages>
        <MessagesLink
          href={messagesUrl}
          onClick={this.menuLinkOnClick}
          title="Messages"
        >
          <Icon name="comments" />
          <Counter
            id="unread-messages"
            className={unreadMessages === 0 && "hidden"}
          >
            {unreadMessages}
          </Counter>
        </MessagesLink>
      </Messages>
    );
  }
}

MessagesNotifications.propTypes = {
  messagesUrl: PropTypes.string.isRequired,
  unreadMessages: PropTypes.number.isRequired,
};

export default MessagesNotifications;
